/**
 * 
 * For submitting and managing the ShapeJS IDE 2.0 parameter form.
 * 
 */

var ShapeJsFormView = require('js/lib/views/ShapeJS/ShapeJsForm');
var $               = require('js/sw-jquery/sw-jquery');
var _               = require('underscore');

var FIELD_NAMES = {
  tag:          'shapeJs[modelProperties][tag]',
  category:     'shapeJs[modelProperties][category]',
  script:       'shapeJs[script]',
  defaultName:  'shapeJs[modelProperties][defaultName]'
};

var FIELD_VALUES = {
  tag:      'ShapeJS',
  category: '104'
};

var ShapeJsIDEForm = ShapeJsFormView.extend({
  events: {
    'submit': 'submitForm'
  },

  /**
   * Formats data so it's consumable by our GenerateShapeJs controller.
   * @return {array} Array formatted to be added to FormData.
   */
  formatFormData: function() {
    var formData = this.$el.serializeArray();
    var formattedData = [];

    // Sketchy renaming of parameters and handling unneeded inputs.
    _.each(formData, function(formInput) {
      var currentName = formInput.name;

      switch(formInput.name) {
        case 'material':
        case 'tabs':
        case formInput.name.indexOf('filename') > -1:
          return;
        case 'appId':
          formInput.name = 'shapeJs[' + currentName + ']';
          break;
        case 'shapejs-script':
          formInput.name = FIELD_NAMES.script;
          break;
        case 'title':
          formInput.name = FIELD_NAMES.defaultName;
          break;
        default:
          formInput.name = 'shapeJs[params][' + currentName + '][value]';
      }

      formattedData.push(formInput);
    });

    // Add tag name to data.
    var tagName = {
      name:   FIELD_NAMES.tag,
      value:  FIELD_VALUES.tag
    };

    formattedData.push(tagName);

    // Add a category to data.
    var category = {
      name:   FIELD_NAMES.category,
      value:  FIELD_VALUES.category
    };

    formattedData.push(category);

    // Add and process file inputs in a consumable format for our servers.
    var fileInputs = this.$(':file');
    _.each(fileInputs, function(fileInput) {
      formattedData.push({
        name:   'shapeJs[params][' + fileInput.name + '][value]',
        value:  fileInput.files[0]
      });      
    });

    return formattedData;
  },

  submitForm: function(e) {
    e.preventDefault();

    // Appends data to form data so can submit files with ajax.
    var data = this.formatFormData();
    var formData = new window.FormData();
    _.each(data, function(item) {
      formData.append(item.name, item.value);
    });

    var self = this;
    $.ajax({
      type:'POST',
      url: self.$el.attr('action'),
      headers: {'x-requested-with': 'XMLHttpRequest'},
      data: formData,
      dataType: 'json',
      contentType: false,
      processData: false,
      xhrFields: {
        withCredentials: true
      },
      success: function(response) {
        self.pollModelProcessing(response);
      }
    });
  }

});

module.exports = ShapeJsIDEForm;
